import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from "@sentry/react"
import { Toaster } from 'sonner'
import mixpanel from 'mixpanel-browser'

import './index.css'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { AppProvider } from './components/AppContext.tsx'
import { CryptoProvider } from './contexts/CryptoContext.tsx'
import ProtectedRoute from './components/ProtectedRoute.jsx'
import ChatApp from './pages/ChatApp.jsx'
import LoginPage from './pages/LoginPage.jsx'
import ForgotPasswordPage from './pages/ForgotPasswordPage.tsx'
import ResetPasswordPage from './pages/ResetPasswordPage.tsx'
import OnboardingPage from './pages/OnboardingPage.jsx'
import SmartErrorBoundary from './components/SmartErrorBoundary.jsx'

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    sendDefaultPii: true
  });
}

// Initialize Mixpanel only in production
if (import.meta.env.VITE_MIXPANEL_TOKEN) {
  mixpanel.init(import.meta.env.VITE_MIXPANEL_TOKEN, {
    autocapture: true,
    record_sessions_percent: 100,
    api_host: 'https://api-eu.mixpanel.com',
  })
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <BrowserRouter>
      <SmartErrorBoundary>
        <CryptoProvider>
          <AppProvider>
            <Toaster position="bottom-right"  />
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />
              <Route path="/onboarding" element={<OnboardingPage />} />
              {/* Protected routes */}
              <Route
                path="/*"
                element={
                  <ProtectedRoute>
                    <ChatApp />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </AppProvider>
        </CryptoProvider>
      </SmartErrorBoundary>
    </BrowserRouter>
  </StrictMode>,
)
